import { render, staticRenderFns } from "./ZipCode.vue?vue&type=template&id=96da052c"
import script from "./ZipCode.vue?vue&type=script&lang=js"
export * from "./ZipCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports